import { useState } from "react";

// ----> ROUTER DOM IMPORTATION
import { Link, useNavigate } from "react-router-dom";


// url front
import { UrlClient } from "../constants/constants.js";


// component import
import { SideBar } from "../../components/sidebar/SideBar.jsx";

// ----> IMAGE IMPORTATION
import logoGlobal from "../../assets/logo-global.png";

// ----> gvm logo
import gvmLog from "../../assets/gvm-log.png";


// TRANSLATION
import { useTranslation } from "react-i18next";


// language
import { LANGUAGE } from "../../config/appConf.js";



export const NavBarComp = () => {

  // ----> USETRANSLATIONS 
  const [t, i18n] = useTranslation("global");

  // GET the useNavigate
  const navigate = useNavigate();


  // ----> Language configuration
  const initialLang = LANGUAGE === "en" ? "English (en)" : "Español (es)";

  const [langTxt, setLangTxt] = useState(initialLang);
  const [viewNoti, setViewNoti] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [setting, setSetting] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);


  // funcion para para cerrar el componente setting
  const onHandleCloseOpenSetting = () => {
    // setSetting(false);
    setSetting(!setting);
  };


  // funcion para cambiar el idioma
  const onChangeLanguage = ({ target }) => {
    if (target.value === "es") {
      setLangTxt("Español (es)");
      i18n.changeLanguage(target.value);
      localStorage.setItem("lang", target.value);
    }

    if (target.value === "en") {
      setLangTxt("English (en)");
      i18n.changeLanguage(target.value);
      localStorage.setItem("lang", target.value);
    }

    setViewNoti(!viewNoti);

    setTimeout(() => {
      setViewNoti(null);
    }, 3500)

  };


  // ----> HANDLE LOGOUT
  const onLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };


  return (
    <>
      {
        setting && (<SideBar onClose={onHandleCloseOpenSetting} />)
      }

      {/* MENU PARA LA VERSION MOBILE */}
      {
        mobileMenu && (
          <>
            <div onClick={() => setMobileMenu(!mobileMenu)} className="mobile-container-menu">
              <div onClick={(event) => event.stopPropagation()} className="mobile-navbar-container">
                <div className="p-1 d-flex f-d-column">
                  {/* DASHBOARD */}
                  <div style={{ alignItems: 'center' }} className="d-flex border-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house-gear-fill" viewBox="0 0 16 16">
                      <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5Z" />
                      <path d="M11.07 9.047a1.5 1.5 0 0 0-1.742.26l-.02.021a1.5 1.5 0 0 0-.261 1.742 1.5 1.5 0 0 0 0 2.86 1.504 1.504 0 0 0-.12 1.07H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6 4.724 4.724a1.5 1.5 0 0 0-1.654 1.03Z" />
                      <path d="m13.158 9.608-.043-.148c-.181-.613-1.049-.613-1.23 0l-.043.148a.64.64 0 0 1-.921.382l-.136-.074c-.561-.306-1.175.308-.87.869l.075.136a.64.64 0 0 1-.382.92l-.148.045c-.613.18-.613 1.048 0 1.229l.148.043a.64.64 0 0 1 .382.921l-.074.136c-.306.561.308 1.175.869.87l.136-.075a.64.64 0 0 1 .92.382l.045.149c.18.612 1.048.612 1.229 0l.043-.15a.64.64 0 0 1 .921-.38l.136.074c.561.305 1.175-.309.87-.87l-.075-.136a.64.64 0 0 1 .382-.92l.149-.044c.612-.181.612-1.049 0-1.23l-.15-.043a.64.64 0 0 1-.38-.921l.074-.136c.305-.561-.309-1.175-.87-.87l-.136.075a.64.64 0 0 1-.92-.382ZM12.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
                    </svg>
                    <Link className="link-navigation" to="/dashboard">Dashboard</Link>
                  </div>
                  {/* SEGUIMIENTOS */}
                  <div style={{ alignItems: 'center' }} className="d-flex border-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-binoculars-fill" viewBox="0 0 16 16">
                      <path d="M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z" />
                    </svg>
                    <Link className="link-navigation" to="/tracking-case">{t("NavBarComp.tracks")}</Link>
                  </div>
                  {/* REPORTAR CASO */}
                  <div style={{ alignItems: 'center' }} className="d-flex border-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal-plus" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z" />
                      <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                      <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                    </svg>
                    <Link className="link-navigation" to="/create-case">{t("NavBarComp.reportCase")}</Link>
                  </div>
                </div>
                {/* CHANGE THE LANGUAGE */}
                <div className="p-1"><strong>{t("NavBarComp.language")}</strong></div>
                <div className="p-1">
                  <select
                    className="control-select"
                    value={langTxt}
                    onChange={onChangeLanguage}>
                    <option value="es">Español (es)</option>
                    <option value="en">English (en)</option>
                  </select>
                </div>
                {/* CONTACTO */}
                <div className="p-1 border-bottom">
                  <h4>Contacto</h4>
                </div>
                {/* TELEFONO */}
                <div className="p-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-forward-fill" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                  </svg>
                  <strong style={{ padding: '0.2rem 0' }}>Call Center</strong>
                  <div>
                    <span style={{ color: 'blue', textDecoration: 'underline' }}>1 (809) 333-1100</span>
                  </div>
                </div>
                {/* CORREO */}
                <div className="p-1">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                    </svg>
                    <strong style={{ padding: '0.2rem 0' }}>Correo</strong>
                  </div>
                  <div>
                    <span style={{ color: 'blue', textDecoration: 'underline' }}>service@global-medica.com</span>
                  </div>
                </div>
                {/* REDES SOCIALES */}
                <div className="p-1">
                  <strong>Redes Sociales</strong>
                </div>
                <div className="social-media-parent-mobile">
                  {/* INSTAGRAM LOGO */}
                  <div className="container-social-media">
                    <a href="https://www.instagram.com/globalmedica/?igshid=NTc4MTIwNjQ2YQ" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                      </svg>
                    </a>
                  </div>
                  {/* FACEBOOK LOGO */}
                  <div className="container-social-media">
                    <a href="https://www.facebook.com/gmglobalmedica" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                      </svg>
                    </a>
                  </div>
                  {/* LINKEDIN */}
                  <div className="container-social-media">
                    <a href="https://www.linkedin.com/company/global-m%C3%A9dica/" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                      </svg>
                    </a>
                  </div>
                  {/* YOUTUBE */}
                  <div className="container-social-media">
                    <a href="https://www.youtube.com/channel/UCWT2KUVVms56vwB0N9r8qKQ" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16">
                        <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                      </svg>
                    </a>
                  </div>
                </div>
                {/* LOGOUT */}
                <div className="container-btn-logout">
                  <button className="btn-logout" onClick={onLogout}>
                    {t("NavBarComp.logout")}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-right" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z" />
                      <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </>
        )
      }
      {
        viewNoti && (
          <div className="set-lang-notification">
            <div className="card-notification">
              <div className="wrapper-animation-check">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" /> <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
              </div>
              <h4>{`${t("NavBarComp.changeLang")} ${langTxt}`}</h4>
            </div>
          </div>
        )
      }
      <div className="navbar-container">
        <div className="navbar"> {/* DAR DISPLAY FLEX */}
          {/* MENU HAMBERGUER FOR MOBILE */}
          {/* {
            window.screen.width < 769 && (
              <div className="btn-mobile">
                <button onClick={() => setMobileMenu(!mobileMenu)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-list" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                  </svg>
                </button>
              </div>
            )
          } */}
          {/* Logo de la compañia */}
          <div>
            {
              ["www.gmd-customer.com", "gmd-customer.com"].includes(UrlClient) ? (<img className="logo-company" src={logoGlobal} alt="Global Logo" />) : (<img className="logo-company" src={gvmLog} alt="GVM Logo" />)
            }
          </div>
          {
            window.screen.width >= 769 && (
              <>
                {/* NAVEGACION */}
                {/* <div className="link-container">
                  <div>
                    <NavLink className={({ isActive }) => `link-navigation ${isActive ? "active" : ""}`} to="/contacts">{t("NavBarComp.contactos")}</NavLink>
                  </div>
                  <div>
                    <NavLink className={({ isActive }) => `link-navigation ${isActive ? "active" : ""}`} to="/create-case">{t("NavBarComp.reportCase")}</NavLink>
                  </div>
                </div> */}
              </>
            )
          }
        </div>
        {/* LOGOUT */}

        <div className="btn-profile">
          {
            window.screen.width >= 769 && (
              <>
                <div>

                </div>
                <div>

                </div>
              </>
            )
          }

          <button type="button" onClick={onHandleCloseOpenSetting}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="var(--first-color)" className="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
              <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" />
            </svg>

          </button>
          {
            window.screen.width >= 769 && (
              openMenu && (
                <div className="card-menu">
                  <div className="p-1">
                    <strong>{t("NavBarComp.language")}</strong>
                    {/* INPUT SELECT LANGUAGE */}
                    <div className="mt-small">
                      <select className="control-select" value={langTxt} onChange={onChangeLanguage}>
                        <option value="es">Español (es)</option>
                        <option value="en">English (en)</option>
                      </select>
                    </div>
                  </div>
                  <div className="container-btn-logout">
                    <button className="btn-logout" onClick={onLogout}>
                      Logout
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z" />
                        <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
              )
            )
          }
        </div>
      </div>
    </>
  );
};